import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LogIn } from 'lucide-react'
import { SsoSetupScreen } from '@/screens/federation/SCR-142-sso'

// SCR-142 Single sign-on (identity federation area).
export const Route = createFileRoute('/_app/org/sso')({
  staticData: {
    screen: {
      id: 'SCR-142',
      title: 'Single sign-on',
      group: 'Organisation',
      perm: 'identity.manage',
      order: 5,
      eyebrow: 'Organisation · Security',
      description: 'Let people sign in with your company’s identity provider, and keep members in sync with SCIM.',
      icon: LogIn,
    },
  },
  validateSearch: z.object({
    tab: z.enum(['sso', 'scim']).optional().catch(undefined),
    connection: z.string().max(100).optional().catch(undefined),
    test: z.enum(['passed', 'failed']).optional().catch(undefined),
  }),
  component: SsoSetupScreen,
})
